export default {
  about: 'حول',
  allExperiences: 'كل التجارب',
  amenities: 'المرافق',
  apply: 'تطبيق',
  at: 'في',
  avail: 'التوفر',
  book: 'احجز',
  bookExperience: 'احجز التجربة',
  by: 'بواسطة',
  chooseATime: 'اختر وقتًا لـ {{title}}',
  comingSoon: 'قريبًا',
  curatedRecommendations: 'توصيات مختارة',
  dateOfExperience: 'تاريخ التجربة',
  details: 'التفاصيل',
  durationHour: 'ساعة',
  durationHours: 'ساعات',
  durationMinutes: 'د',
  eventSize: 'حجم الفعالية',
  experienceBenefits: {
    benefits: {
      additionalBonusPoints:
        '<p><strong>اكسب 4 نقاط إضافية</strong> عن كل 1 دولار أمريكي مؤهل يتم إنفاقه عند الحجز ببطاقة World of Hyatt الائتمانية</p>',
      additionalBonusPointsTier:
        '<p><strong>اكسب ما يصل إلى 30% نقاط إضافية</strong> اعتمادًا على مستوى عضويتك</p>',
      basePoints:
        '<p><strong>اكسب 10 نقاط أساسية</strong> عن كل 1 دولار أمريكي مؤهل يتم إنفاقه عند تسجيل الدخول إلى حساب World of Hyatt لحجز هذه التجربة</p>',
      basePointsEarn:
        '<p><strong>اكسب 5 نقاط أساسية</strong> عن كل 1 دولار أمريكي مؤهل يتم إنفاقه عند تسجيل الدخول إلى حساب World of Hyatt لحجز هذه التجربة</p>',
      payWithPoints: '<p><strong>ادفع بالنقاط</strong> عند حجز هذه التجربة</p>',
    },
  },
  experienceCalendar: 'تقويم التجربة',
  experienceCancelled: 'تم إلغاء التجربة',
  experienceStartingPrice: 'ابتداءً من {{price}}',
  experienceTotalPrice: 'الإجمالي {{price}}',
  featuredExperiences: 'تجاربنا المميزة',
  groupSize: 'حجم المجموعة',
  hostedBy: 'يستضيفها',
  inPartnershipWith: 'بالشراكة مع',
  learnMore: 'اعرف المزيد',
  location: 'الموقع',
  maxPartySize: 'بحد أقصى {{maxGroupSize}} مقعد لكل مجموعة',
  maxPartySizes: 'بحد أقصى {{maxGroupSize}} مقاعد لكل مجموعة',
  noAvailability: 'لا يوجد توفر',
  notFoundExperienceSubtitle: 'ربما تم إلغاء نشرها، أو لم يعد الرابط صالحًا.',
  deadLinkRecoverySubtitle: 'اكتشف تجارب أخرى متاحة للحجز',
  notFoundExperienceTitle: 'هذه التجربة لم تعد متاحة',
  readLess: 'اقرأ أقل',
  readMore: 'اقرأ المزيد',
  reminders: 'التذكيرات',
  reviewPlural: 'مراجعات',
  reviewSingular: 'مراجعة',
  reviews: 'المراجعات',
  searchAll: 'بحث في الكل',
  searchAllExperiences: 'بحث في جميع التجارب',
  seeMore: 'عرض المزيد',
  seeOtherDates: 'عرض تواريخ أخرى',
  select: 'اختيار',
  selectDateValidation: 'يرجى اختيار التاريخ',
  selectDuration: 'المدة',
  selectParticipantValidation: 'يرجى اختيار المشاركين',
  selectSession: 'اختر الجلسة',
  sessionsCount: '{{count}} أوقات — اختر وقتًا',
  selectSessionValidation: 'يرجى اختيار الجلسة',
  selectStartTime: 'وقت البدء',
  slotLeft: 'تبقى {{remainSlots}} مقعد',
  slotsLeft: 'تبقى {{remainSlots}} مقاعد',
  spotsLeft: '{{count}} متبقٍّ',
  spotsLeftAriaLabel: '{{count}} مقعد متبقٍّ',
  soldOut: 'نفدت الكمية',
  theFollowingVideoDoesNotContainAnyAudio: 'لا يحتوي الفيديو التالي على أي صوت',
  ticketSalesClose: 'مبيعات التذاكر تنتهي',
  ticketSalesCloseIn: 'تنتهي مبيعات التذاكر بعد',
  ticketSalesClosed: 'انتهت مبيعات التذاكر',
  ticketSalesOpen: 'مبيعات التذاكر مفتوحة',
  ticketSalesOpenIn: 'تبدأ مبيعات التذاكر بعد',
  upTo: 'حتى',
  viewAllExperiences: 'عرض جميع التجارب',
  viewPrivateSessAvailability: 'عرض توفر الجلسات الخاصة',
  whatsIncluded: 'ما يشمله',
  whatWeDo: 'ما الذي سنفعله',
  whereWeAre: 'أين سنكون',
};
